import { extractString } from '../../utils/sanitizeData';

interface VendorCustomerCardsProps {
  vendor?: {
    name?: unknown;
    address?: unknown;
    vatNumber?: unknown;
    email?: unknown;
    iban?: unknown;
  };
  customer?: {
    name?: unknown;
    address?: unknown;
    vatNumber?: unknown;
    email?: unknown;
    accountNumber?: unknown;
  };
}

export default function VendorCustomerCards({
  vendor = {},
  customer = {},
}: VendorCustomerCardsProps) {
  const vendorName = extractString(vendor.name, '—');
  const vendorAddress = extractString(vendor.address, '—');
  const vendorVat = extractString(vendor.vatNumber, '—');
  const vendorEmail = extractString(vendor.email, '—');
  const vendorIban = extractString(vendor.iban, '—');

  const customerName = extractString(customer.name, '—');
  const customerAddress = extractString(customer.address, '—');
  const customerVat = extractString(customer.vatNumber, '—');
  const customerEmail = extractString(customer.email, '—');
  const customerAccount = extractString(customer.accountNumber, '—');

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
      {/* Vendor Card */}
      <div className="rounded-2.5xl bg-white dark:bg-boxdark border border-brand-line dark:border-strokedark p-5 sm:p-6 shadow-card">
        <div className="flex items-center gap-2 mb-4 pb-3 border-b border-brand-line dark:border-strokedark">
          <div className="w-2 h-2 rounded-full bg-brand-vib" />
          <h2 className="text-xs font-mono font-bold uppercase tracking-wider text-brand-navy dark:text-white">
            Vendor Details
          </h2>
        </div>

        <div className="space-y-3">
          <div>
            <div className="text-[10px] font-mono text-brand-soft dark:text-bodydark2 uppercase tracking-wider">
              Legal Business Name
            </div>
            <div className="text-sm font-bold text-brand-navy dark:text-white mt-0.5">
              {vendorName}
            </div>
          </div>

          <div>
            <div className="text-[10px] font-mono text-brand-soft dark:text-bodydark2 uppercase tracking-wider">
              Billing Address
            </div>
            <div className="text-xs text-brand-muted dark:text-bodydark mt-0.5 leading-relaxed">
              {vendorAddress}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 pt-2">
            <div>
              <div className="text-[10px] font-mono text-brand-soft dark:text-bodydark2 uppercase tracking-wider">
                VAT / Tax ID
              </div>
              <div className="text-xs font-mono font-semibold text-brand-navy dark:text-white mt-0.5">
                {vendorVat}
              </div>
            </div>
            <div>
              <div className="text-[10px] font-mono text-brand-soft dark:text-bodydark2 uppercase tracking-wider">
                Billing Email
              </div>
              <div className="text-xs font-mono text-brand-muted dark:text-bodydark mt-0.5 truncate">
                {vendorEmail}
              </div>
            </div>
          </div>

          <div className="pt-2 border-t border-brand-line/60 dark:border-strokedark">
            <div className="text-[10px] font-mono text-brand-soft dark:text-bodydark2 uppercase tracking-wider">
              Bank IBAN / Wire
            </div>
            <div className="text-xs font-mono font-bold text-brand-navy dark:text-white mt-0.5">
              {vendorIban}
            </div>
          </div>
        </div>
      </div>

      {/* Customer Card */}
      <div className="rounded-2.5xl bg-white dark:bg-boxdark border border-brand-line dark:border-strokedark p-5 sm:p-6 shadow-card">
        <div className="flex items-center gap-2 mb-4 pb-3 border-b border-brand-line dark:border-strokedark">
          <div className="w-2 h-2 rounded-full bg-brand-green" />
          <h2 className="text-xs font-mono font-bold uppercase tracking-wider text-brand-navy dark:text-white">
            Customer Details (Bill To)
          </h2>
        </div>

        <div className="space-y-3">
          <div>
            <div className="text-[10px] font-mono text-brand-soft dark:text-bodydark2 uppercase tracking-wider">
              Recipient Company
            </div>
            <div className="text-sm font-bold text-brand-navy dark:text-white mt-0.5">
              {customerName}
            </div>
          </div>

          <div>
            <div className="text-[10px] font-mono text-brand-soft dark:text-bodydark2 uppercase tracking-wider">
              Delivery / Billing Address
            </div>
            <div className="text-xs text-brand-muted dark:text-bodydark mt-0.5 leading-relaxed">
              {customerAddress}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 pt-2">
            <div>
              <div className="text-[10px] font-mono text-brand-soft dark:text-bodydark2 uppercase tracking-wider">
                Tax Registration
              </div>
              <div className="text-xs font-mono font-semibold text-brand-navy dark:text-white mt-0.5">
                {customerVat}
              </div>
            </div>
            <div>
              <div className="text-[10px] font-mono text-brand-soft dark:text-bodydark2 uppercase tracking-wider">
                Account Number
              </div>
              <div className="text-xs font-mono font-semibold text-brand-navy dark:text-white mt-0.5">
                {customerAccount}
              </div>
            </div>
          </div>

          <div className="pt-2 border-t border-brand-line/60 dark:border-strokedark">
            <div className="text-[10px] font-mono text-brand-soft dark:text-bodydark2 uppercase tracking-wider">
              Accounts Payable Contact
            </div>
            <div className="text-xs font-mono text-brand-muted dark:text-bodydark mt-0.5">
              {customerEmail}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
